// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__h9aTb","content":"styles_content__2kRV9"};